import axiosInstance from "./axiosInstance";

// Get all accents
export const fetchAccents = async () => {
    const response = await axiosInstance.get("/accent/getall");
    return response.data;
};

// Create a new accent
export const createAccent = async (data) => {
    const response = await axiosInstance.post("/accent", data);
    return response.data;
};

// Update a accent
export const updateAccent = async ({ id, data }) => { 
    const response = await axiosInstance.put(`/accent/${id}`, data);
    return response.data;
};

// Delete a accent
export const deleteAccent = async (data) => {
    await axiosInstance.delete(`/accent`, {
        params: data
    });
};
